import React, { Component } from "react";
import CKEditor from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

class RichTextEditor extends Component {
  sendData = editor => {
    this.props.parentCallback(editor.getData());
  };
  render() {
    return (
      <CKEditor
        editor={ClassicEditor}
        onInit={editor => {
          console.log("Editor is ready to use!", editor);
        }}
        onChange={(event, editor) => {
          const data = editor.getData();
          this.sendData(editor);
          console.log({ event, editor, data });
        }}
        onBlur={(event, editor) => {
          console.log("Blur.", editor);
        }}
        onFocus={(event, editor) => {
          console.log("Focus.", editor);
        }}
        data = {this.props.data !== undefined ? this.props.data : "" }
      />
    );
  }
}

export default RichTextEditor;
